/* assets/pro-checkout-restrictions.js */
(() => {
  /* -------- helpers -------- */
  const isPro   = (item) => /(\s|\|)pro$/i.test(item.variant_title ?? item.title);
  const dollars = (c)    => c / 100;                       // cents → dollars
  const PRO_MIN = 2500;                                    // $2 500 CAD

  /* Track cart snapshots */
  let lastCartKey      = null;  // most-recently validated cart
  let dismissedCartKey = null;  // cart snapshot the user dismissed

  /* Build a unique “signature” for the cart */
  const makeCartKey = (cart) =>
    cart.items
      .map((l) => `${l.id}:${l.quantity}`)
      .sort()
      .join('|');

  /* -------- core validator -------- */
  async function validateCart() {
    const cart   = await fetch('/cart.js').then((r) => r.json());
    lastCartKey  = makeCartKey(cart);

    const modal  = document.getElementById('pro-restriction-modal');
    const btns   = document.querySelectorAll(
      '[name="checkout"], button#Checkout, button[name="redirect-checkout"]',
    );
    if (!modal || !btns.length) return;

    /* Reset UI */
    btns.forEach((b) => (b.disabled = false));
    modal.classList.add('hidden');

    /* Work out Pro totals */
    const proLines   = cart.items.filter(isPro);
    if (!proLines.length) {
      dismissedCartKey = null;                            // cart now valid
      return;
    }

    const otherLines = cart.items.filter((l) => !isPro(l));
    const proTotal   = dollars(
      proLines.reduce((sum, l) => sum + l.final_line_price, 0),
    );

    /* Decide if we need to block checkout */
    let error = '';
    if (otherLines.length) {
      error =
        'Pro size orders cannot be combined with non-Pro size products.';
    } else if (proTotal < PRO_MIN) {
      error =
        `Pro size orders require a minimum purchase of $${PRO_MIN.toLocaleString()} CAD. ` +
        `Your current Pro size subtotal is $${proTotal.toFixed(2)}.`;
    }

    /* Apply restriction */
    if (error) {
      btns.forEach((b) => (b.disabled = true));

      /* Show modal only if user hasn’t dismissed this exact cart */
      if (dismissedCartKey !== lastCartKey) {
        modal.querySelector('.pro-msg').textContent =
          `Pro size orders require a minimum purchase of $${PRO_MIN.toLocaleString()} CAD ` +
          `(before taxes & after discounts). Your current Pro size subtotal is ` +
          `$${proTotal.toFixed(2)}. Pro sizes cannot be combined with non-Pro size ` +
          `products. Each Pro size order is custom-made and requires approximately ` +
          `two weeks before shipping — a small wait for truly transformative results.`;
        modal.classList.remove('hidden');
      }
    } else {
      dismissedCartKey = null;                            // cart valid again
    }
  }

  const revalidate = (delay = 60) => setTimeout(validateCart, delay);

  /* -------- event wiring -------- */
  document.addEventListener('DOMContentLoaded', () => {
    revalidate(0);

    /* Close button → hide modal & remember dismissal */
    const closeBtn = document.querySelector(
      '#pro-restriction-modal .pro-modal__close',
    );
    closeBtn?.addEventListener('click', () => {
      document.getElementById('pro-restriction-modal')?.classList.add('hidden');
      dismissedCartKey = lastCartKey;
    });
  });

  document.addEventListener('cart:updated', () => revalidate(0));

  document.addEventListener('change', (e) => {
    if (e.target.matches('input[name^="updates"]')) revalidate();
  });

  /* Patch fetch so any /cart* Ajax call triggers validation */
  const nativeFetch = window.fetch;
  window.fetch = function (...args) {
    return nativeFetch.apply(this, args).then((res) => {
      try {
        const url = typeof args[0] === 'string' ? args[0] : args[0].url;
        if (/\/cart(\/|\.|$)/.test(url)) revalidate();
      } catch (_) {}
      return res;
    });
  };
})();
